import React, {useCallback, useEffect, useRef, useState} from "react";
import {observer} from "mobx-react";
import classNames from "classnames";
import useWithStore from "@/Hooks/useWithStore";
import useScrollDirection from "@/Hooks/useScrollDirection";
import useScrollHeader from "@/Hooks/Effects/GlobalListeners/useScrollHeader";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import {useAllStore} from "@/Stores/useAllStore";
import {useLocationStore} from "@/Stores/Site/LocationStore";
import {useModalStore as useModalStoreProfile} from "@/Stores/Site/Profile";
import {useBasketStore} from "@/Stores/Site/Basket";
import {selectorOpenProfileDrawer} from "@/Stores/Site/Profile/Selectors";
import {useModalStore} from "@/Stores/Site/ModalStore";
import Link from "@/Layouts/Link";
import Country from "@/Pages/Header/Country";
import Svg from "@/Components/Svg";
import Picture from "@/Components/Picture";
import MainLogo from "@/Components/MainLogo";
import BasketButton from "@/Components/Site/BasketButton";
import SearchForm from "@/Components/Site/SearchForm";
import MobileMenuDrawer from "@/Components/Drawer/MobileMenuDrawer";
import CatalogMobileMenuDrawer from "@/Components/Drawer/CatalogMobileMenuDrawer";
import "@/Scss/header.scss";
import '@/Pages/Header/scss/index.scss';

const Header = (props) => {
    const {mobileApp = false} = props;

    const scrollDirection = useScrollDirection();

    /**
     * Манипуляции со скролом для фиксации шапки
     */
    useScrollHeader();

    const headerRef = useRef(null);

    const headerHeight = useAllStore((state) => state.headerHeight);
    const setHeight = useAllStore((state) => state.setHeight);

    const headerClasses = classNames('header', props.className, {
        'header--show': scrollDirection === "up",
        'header--hide': scrollDirection === "down",
    });

    useEffect(() => {
        const updateHeight = () => {
            if (headerRef.current) {
                setHeight(headerRef.current.offsetHeight);
            }
        };

        const observer = new ResizeObserver(updateHeight);
        if (headerRef.current) {
            observer.observe(headerRef.current);
        }

        return () => observer.disconnect();
    }, []);

    // const [headerApp, setHeaderApp] = useState(sessionStorage.getItem('headerApp'));
    //
    // const installAppsClose = () => {
    //     sessionStorage.setItem('headerApp', '1');
    //     setHeaderApp(sessionStorage.getItem('headerApp'));
    // };
    //
    // const installApps = () => {
    //     if (headerApp !== null) {
    //         return null;
    //     }
    //
    //     return <>
    //         <div className={`container`}>
    //             <div className={`installApps`}>
    //                 <Svg id={`dagger-close`} onClick={() => installAppsClose()}
    //                      className={`MuiSvgIcon-root svg__dagger-close mr8`} />
    //                 <Svg id={`installIcon`} className={`svg__installIconAppHeader`} />
    //                 <div className={`installApps__text`}>
    //                     <p className={`first`}>Откройте в приложении</p>
    //                     <p className={``}>{installAppsText}</p>
    //                 </div>
    //                 <a href={`https://platina.onelink.me/XKls/3h9xijzw`}
    //                    className={`installApps__openApp`}
    //                    role={`button`}
    //                 >
    //                     Открыть
    //                 </a>
    //             </div>
    //         </div>
    //         <div className={`installAppsLine`}></div>
    //     </>
    // };

    if (mobileApp) return null;

    return (
        <header
            ref={headerRef}
            id={`header`}
            className={headerClasses}
            style={{transform: scrollDirection === "down" ? `translateY(-${headerHeight}px)` : "translateY(0)"}}
        >
            {/*{installApps()}*/}
            <Sale {...props} />
            <Info {...props} />
            <Main {...props} />
        </header>
    );
}

/**
 * Какая-то акция
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
const Sale = (props) => {
    const {mainSale = {}} = props;
    const [headerMainSale, setHeaderMainSale] = useState(null);
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        const stored = sessionStorage.getItem("headerMainSale");
        setHeaderMainSale(stored);
        setIsMounted(true);
    }, []);

    /**
     * Закрыть главную акцию
     */
    const closeMainSale = () => {
        sessionStorage.setItem('headerMainSale', '1');
        setHeaderMainSale('1');
    }

    if (!isMounted || headerMainSale !== null || mainSale === null) {
        return null;
    }

    const {img_main_sale = '', img_main_sale_mobile = '', title = '', alias = ''} = mainSale;

    return <div id={`stickyMainSale`} className={`headerMainSale`}>
        <div className={`headerMainSale__cross`} onClick={() => closeMainSale()}>
            <Svg id={`dagger-close`} className={`svg__dagger-close svg__dagger-close_mainSale`} />
        </div>
        <Link href={`/stocks/${alias}`}>
            <Picture src={img_main_sale} srcMobile={img_main_sale_mobile} alt={title} />
        </Link>
    </div>
}

/**
 * Информационная часть header
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Info = (props) => {
    const {city} = props;

    const openModalSelectCity = useLocationStore(state => state.openModalSelectCity);

    return (
        <div className={`infoContainer`}>
            <div className={`container`}>
                <div className={`headerInfo`}>
                    <Country {...props} />
                    <div className={`headerInfo__location`} onClick={openModalSelectCity}>
                        <Svg id={`location`} className={`svg__location`} />
                        {city}
                    </div>
                    <div className={`headerInfo__phones`}>
                        <a onClick={() => {
                            reachGoalYM('phone_click');
                            reachGoalGA('phone_click');
                        }}
                           href="tel:88003501595">
                            <div className={`phone`}>8 800 350-15-95</div>
                        </a>
                        <a onClick={() => {
                            reachGoalYM('phone_click');
                            reachGoalGA('phone_click');
                        }}
                           href="tel:+79109522022">
                            <div className={`phone`}>8 910 952-20-22</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

/**
 * Главная часть header
 * @type {IReactComponent}
 */
const Main = observer((props) => {
    const {stores = {}} = props;
    const {mobileMenuStore = {}, subMenuStore = {}} = stores;

    const catalogClasses = classNames('headerMain__catalog', props.className, {
        'open': subMenuStore.open,
    });

    return (
        <div className={`mainContainer`}>
            <div className={`container`}>
                <div className={`headerMain`}>
                    <div className={`headerMain__menu`}>
                        <div
                            className={`headerMain__icon headerMain__icon--menu`}
                            onClick={() => mobileMenuStore.openMobileMenu()}
                        >
                            <Svg id={`mobile-menu`} className={`svg__mobile-menu`} />
                        </div>
                    </div>
                    <MainLogo />
                    <div className={catalogClasses} onClick={() => subMenuStore.openSubMenu()}>
                        {subMenuStore.open ?
                            <Svg id={`dagger-close`} className={`svg__headerCatalogButtonClose`} />
                            :
                            <Svg id={`headerCatalogButton`} className={`svg__headerCatalogButton`} />
                        }
                        <p className={`text`}>Каталог</p>
                    </div>
                    <div className={`headerMain__searchingForm`}>
                        <SearchForm {...props} />
                    </div>
                    <Icons {...props} />
                </div>
            </div>
            <MobileMenuDrawer {...props} />
            <CatalogMobileMenuDrawer {...props} />
            <CatalogMenu {...props} />
        </div>
    );
});

const Icons = observer((props) => {
    const {stores = {}, authCheck = false, user = {}} = props;
    const {favouritesStore = {}} = stores;
    const {ordersCount = 0, refundsCount = 0} = user;

    const activeOrders = ordersCount + refundsCount;

    const openSearchModal = useModalStore(state => state.openSearchModal);
    const basketCount = useBasketStore(state => state.basketCount);
    const openProfileDrawer = useModalStoreProfile(selectorOpenProfileDrawer);

    return (
        <div className={`headerMain__icons`}>
            <div className={`headerMain__icon headerMain__icon--search`} onClick={() => openSearchModal()}>
                <Svg id={`search`} className={`svg__searchHeader`} />
            </div>
            <div className={`headerMain__icon headerMain__icon--profile`} onClick={() => openProfileDrawer()}>
                <Svg id={`profile`} className={`svg__profile`} />
                {authCheck && activeOrders !== 0 && (<div className={`headerMain__iconDots`}></div>)}
            </div>
            <Link className={`headerMain__icon headerMain__icon--favorites`} href={`/favorites`}>
                <Svg id={`heart-header`} className={`svg__heart`} />
                {favouritesStore.favouritesData.length !== 0 && (
                    <span className={`headerMain__iconDots`}></span>
                )}
            </Link>
            <BasketButton className={`headerMain__icon headerMain__icon--basket inertiaButton`}>
                <Svg id={`headerBasket`} className={`svg__basket`} />
                {basketCount !== 0 && (
                    <span className={`headerMain__basketCount`}>{basketCount}</span>
                )}
            </BasketButton>
        </div>
    );
});

const CatalogMenu = observer((props) => {
    const {stores = {}, imgVersion = '', catalogMenu = []} = props;
    const {subMenuStore = {}} = stores;

    const open = classNames('catalog-sub-menu', props.className, {
        'open': subMenuStore.open,
        'sticky': subMenuStore.stickySubMenu
    });

    const openOverlay = classNames('catalog-sub-menu-overlay', props.className, {
        'open': subMenuStore.open,
        'sticky': subMenuStore.stickySubMenu
    });

    let categories = [], sections = [];
    catalogMenu.map((el, i) => {
        categories.push(
            <Link
                key={el.id}
                className={`catalog-sub-menu__list js-catalogMenuList${i === 0 ? ' active' : ''}`}
                href={`${el.url}`}
                dataSrc={el.img}
                onMouseOver={(e) => subMenuStore.createImg(e, el.id)}
            >
                <Svg id={el.svg} className={`svg__catalogSubMenu`} />
                {el.name}
            </Link>
        );

        // const widthPercent = el.sections.length > 4 ? (100 / el.sections.length).toFixed(2) + '%' : '25%';
        const widthPercent = el.sections.length > 3 ? (100 / el.sections.length).toFixed(2) + '%' : '33%';

        sections.push(
            <div key={el.id}
                 id={`catalog_sub_menu_${el.id}`}
                 className={`catalog-sub-menu__item catalog-sub-menu__item_content${i === 0 ? '' : ' hidden'}`}
            >
                {el.sections.map((items) => {
                    return <div
                        key={items.id}
                        className={`catalog-sub-menu__item_content-list`}
                        style={{width: widthPercent}}
                    >
                        <p className={`catalog-sub-menu__title`}>{items.title}</p>
                        {items.items.map((el) => {
                            return <Link
                                key={el.id}
                                href={`${el.url}`}
                                className={`catalog-sub-menu__list`}
                            >
                                {el.name}
                            </Link>
                        })}
                    </div>
                })}
            </div>
        );
    });

    const Menu = useCallback(() => {
        return <>
            <div className={`catalog-sub-menu__item`}>
                <div className={`catalog-sub-menu__title`}>
                    <p>Украшения</p>
                </div>
                {categories}
            </div>
            {sections}
        </>
    }, [catalogMenu]);

    return (
        <>
            <div id={`subMenu`} className={open}>
                <div className={`container`}>
                    <div id={`sub-menu`} className={`catalog-sub-menu__wrapper`}>
                        <Menu />
                        <div id={`newImg`} className={`catalog-sub-menu__item catalog-sub-menu__item_img`}>
                            {subMenuStore.newImg && (
                                <Picture
                                    src={`${subMenuStore.newImg['src']}.jpg?v=${imgVersion}`}
                                    alt={`Красивое фото`}
                                    width={`350`}
                                    height={`350`}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div id={`subMenuOverlay`} className={openOverlay}
                 onClick={() => subMenuStore.handleClickAwaySubMenu()}></div>
        </>
    )
});

export default useWithStore(Header);
